<template>
  <div class="autocomplete">
    <v-autocomplete
      dark
      append-icon
      return-object
      hide-no-data
      :items="parsedPois"
      v-model="result"
      color="#fff"
      :prepend-icon="icons.search"
      @change="onSelection"
    >
      <template v-slot:item="data">
        <v-list-item-avatar>
          <img :src="data.item.image">
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.text"></v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <div class="autocomplete__values"></div>
  </div>
</template>

<script>
  import { mdiMagnify } from '@mdi/js'

  export default {
    name: 'AutocompleteInput',

    props: {
      pois: {
        required: true,
        type: Array,
      },
    },

    data() {
      return {
        icons: {
          search: mdiMagnify,
        },
        result: null,
      }
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },

      parsedPois() {
        return this.pois.map((poi) => {
          const coverImage = poi.image && poi.image.cover || this.$store.state.objects.defaultImages.cover
          return {
            text: poi.business_content[this.locale]?.name,
            slug: poi.slug[this.locale],
            image: coverImage,
          }
        })
      },
    },

    methods: {
      async onSelection() {
        const { slug } = this.result
        const { locale } = this

        const link = { name: 'DetailPage', params: { locale, slug } }

        await this.$router.push(link)
      },
    },
  }
</script>

<style lang="sass" scoped>
  .v-list-item__content
    max-width: 350px

  .autocomplete ::v-deep .theme--light.v-input
    color: #fff !important

  @media (max-width: 500px)
    .v-list-item__content
      max-width: 150px
</style>
